<template>
  <div>
    <h2>Up Costs</h2>

    <label for="homeowner_upcost" class="form-input half">
      <span>Homeowner Up-cost (£)</span>
      <input id="homeowner_upcost" type="text" v-model="upcost_homeowner">
    </label>

    <label for="landlord_upcost" class="form-input half">
      <span>Landlord/Tenant Up-cost (£)</span>
      <input id="landlord_upcost" type="text" v-model="upcost_landlord">
    </label>

    <label for="gas_upcost" class="form-input half">
      <span>Gas Up-cost (£)</span>
      <input id="gas_upcost" type="text" v-model="upcost_gas">
    </label>

    <label for="lpg_upcost" class="form-input half">
      <span>LPG Up-cost (£)</span>
      <input id="lpg_upcost" type="text" v-model="upcost_lpg">
    </label>

    <label for="oil_upcost" class="form-input half">
      <span>Oil Up-cost (£)</span>
      <input id="oil_upcost" type="text" v-model="upcost_oil">
    </label>
    <button @click.prevent="submit" class="submit-button">Update upcosts</button>
  </div>
</template>

<script>
export default {
  name: "Upcosts",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data(){
    return{
      upcost_homeowner: 0,
      upcost_landlord: 0,
      upcost_gas: 0,
      upcost_lpg: 0,
      upcost_oil: 0,
    }
  },
  mounted(){
    this.getUpcosts();
  },
  methods: {
    submit() {
      let data = {
        homeowner: this.upcost_homeowner,
        landlord: this.upcost_landlord,
        gas: this.upcost_gas,
        lpg: this.upcost_lpg,
        oil: this.upcost_oil,
      };
      this.$axios.post(`${this.base}/api/upcosts/update.php`, this.$makeForm(data))
          .then(() => {
            this.$emit('save');
          });
    },
    getUpcosts() {
      this.$axios.get(`${this.base}/api/upcosts/get.php`)
          .then((response) => {
            this.upcost_homeowner = response.data.homeowner;
            this.upcost_landlord = response.data.landlord;
            this.upcost_gas = response.data.gas;
            this.upcost_lpg = response.data.lpg;
            this.upcost_oil = response.data.oil;
          });
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  width: 50%;
}

.form-input {
  width: 100%;
  margin: 1rem 0;
  display: block;

span, input[type=text] {
  width: 100%;
  display: block;
}

span {
  margin-bottom: 0.5rem;
}

&.half {
   width: 40%;
   margin-right: 5%;
   display: inline-block;
 }
}

.form-checkbox {
  margin: 1rem 1rem 1rem 0;
  display: inline-flex;

span, input {
  align-self: center;
}

span {
  margin-left: 0.4rem;
}
}

.submit-button {
  display: block;
  margin: 1rem 0;
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

&:hover {
   background-color: #004885;
   transition: 0.2s;
 }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Upcosts.vue